import Axios from "axios";
import flash from "../../../functions/flash";
import { suspended } from "../../endpoints";

const getSuspendedUsers = async (setLoading, setData, accessToken) => {
  try {
    setLoading(true);
    let res = await Axios.post(suspended, { accessToken });
    setData(res.data.data);
    setLoading(false);
  } catch (e) {
    setData([]);
    setLoading(false);
    if (e.response.status !== 404) flash(e.message, "danger");
  }
};

export default getSuspendedUsers;
